function DefaultImage() {
  return (
    <img
      src="/default_images.png"
      alt="default_program_image"
    />
  );
}
export default DefaultImage;
